import { Link, NavLink, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { RiHome2Fill, RiBriefcase4Line, RiLineChartLine, RiMapPin2Line } from 'react-icons/ri'
import NavbarMobileDropdown from './NavbarMobileDropdown'

const linkClassName = ({ isActive }) =>
  `flex items-center gap-3 px-6 py-3 transition-colors ${
    isActive ? 'bg-secondary-100 text-secondary-700' : 'hover:bg-light'
  }`

export default function NavbarMobileMenu({ lng }) {
  const { t } = useTranslation()

  return (
    <ul className="border-muted-300 divide-muted-300 flex flex-col divide-y border-t font-bold">
      <li>
        <NavLink
          className={linkClassName}
          to={`/${lng}/home`}
        >
          <RiHome2Fill size={20} />
          {t('HOME')}
        </NavLink>
      </li>
      <NavbarMobileDropdown lng={lng} />
      <li>
        <NavLink
          className={linkClassName}
          to={`/${lng}/opportunities`}
        >
          <RiBriefcase4Line size={20} />
          {t('OPPORTUNITIES')}
        </NavLink>
      </li>
      <li>
        <NavLink
          className={linkClassName}
          to={`/${lng}/minerals/alalmnyom-aluminium/prices?CHART=AREA&INTERVAL=MONTH`}
        >
          <RiLineChartLine size={20} />
          {t('MINERALS_PRICES')}
        </NavLink>
      </li>
      <li>
        <Link
          className="hover:bg-light flex items-center gap-3 px-6 py-3 transition-colors"
          to={`/region/map`}
          target="_blank"
        >
          <RiMapPin2Line size={20} />
          {t('REGION_MAP')}
        </Link>
      </li>
    </ul>
  )
}
